module.exports = __webpack_public_path__ + "img/ken05.bd95e558.jpg";